import React from "react";

const IconEvolve = () => {
  return (
    <svg
      width="48"
      height="49"
      viewBox="0 0 48 49"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect y="0.463867" width="48" height="48" rx="24" fill="#006F94" />
      <path
        d="M10.2591 24.2314C9.56783 24.9942 9.13879 26.0548 9.13879 27.2228C9.13879 29.1177 10.271 30.7265 11.8203 31.2628"
        stroke="white"
        stroke-width="1.27636"
        stroke-miterlimit="10"
      />
      <path
        d="M15.479 27.9976C13.5841 28.2478 12.1182 30.0355 12.1182 32.2045C12.1182 34.3735 13.4172 35.9585 15.1572 36.3518"
        stroke="white"
        stroke-width="1.27636"
        stroke-miterlimit="10"
      />
      <path
        d="M12.1301 17.6052C10.5809 18.1415 9.4606 19.7504 9.4606 21.6453C9.4606 23.9812 11.1648 25.8761 13.2742 25.8761C13.4888 25.8761 13.6914 25.8522 13.882 25.8165"
        stroke="white"
        stroke-width="1.27636"
        stroke-miterlimit="10"
      />
      <path
        d="M18.9947 14.1492C18.3154 12.9932 17.1355 12.2185 15.8008 12.2185C13.6913 12.2185 11.9871 14.1134 11.9871 16.4493C11.9871 17.7244 12.4996 18.8805 13.31 19.6551"
        stroke="white"
        stroke-width="1.27636"
        stroke-miterlimit="10"
      />
      <path
        d="M22.2124 21.4784V14.8284C22.2124 12.4926 20.5082 10.5977 18.3988 10.5977C17.2308 10.5977 16.194 11.1816 15.4909 12.0993"
        stroke="white"
        stroke-width="1.27636"
        stroke-miterlimit="10"
      />
      <path
        d="M22.2124 29.7732V27.4492"
        stroke="white"
        stroke-width="1.27636"
        stroke-miterlimit="10"
      />
      <path
        d="M14.5851 34.0994C14.5851 36.4352 16.2894 38.3301 18.3988 38.3301C20.5082 38.3301 22.2124 36.4352 22.2124 34.0994"
        stroke="white"
        stroke-width="1.27636"
        stroke-miterlimit="10"
      />
      <path
        d="M37.7411 24.2314C38.4323 24.9942 38.8613 26.0548 38.8613 27.2228C38.8613 29.1177 37.7292 30.7265 36.1799 31.2628"
        stroke="white"
        stroke-width="1.27636"
        stroke-miterlimit="10"
      />
      <path
        d="M32.5092 27.9976C34.4041 28.2478 35.87 30.0355 35.87 32.2045C35.87 34.2543 34.571 35.9585 32.831 36.3518"
        stroke="white"
        stroke-width="1.27636"
        stroke-miterlimit="10"
      />
      <path
        d="M35.8581 17.6052C37.4074 18.1415 38.5276 19.7504 38.5276 21.6453C38.5276 23.9812 36.8234 25.8761 34.714 25.8761C34.4995 25.8761 34.2969 25.8522 34.1062 25.8165"
        stroke="white"
        stroke-width="1.27636"
        stroke-miterlimit="10"
      />
      <path
        d="M28.9935 14.1492C29.6728 12.9932 30.8526 12.2185 32.1874 12.2185C34.2968 12.2185 36.001 14.1134 36.001 16.4493C36.001 17.7244 35.4886 18.8805 34.6782 19.6551"
        stroke="white"
        stroke-width="1.27636"
        stroke-miterlimit="10"
      />
      <path
        d="M25.7877 14.8284C25.7877 12.4926 27.4919 10.5977 29.6013 10.5977C30.7811 10.5977 31.8418 11.1935 32.5449 12.135"
        stroke="white"
        stroke-width="1.27636"
        stroke-miterlimit="10"
      />
      <path
        d="M25.7877 21.4785V19.5359"
        stroke="white"
        stroke-width="1.27636"
        stroke-miterlimit="10"
      />
      <path
        d="M33.4031 34.0992C33.4031 36.4351 31.6989 38.33 29.5895 38.33C27.48 38.33 25.7758 36.4351 25.7758 34.0992V27.4492"
        stroke="white"
        stroke-width="1.27636"
        stroke-miterlimit="10"
      />
      <path
        d="M26.9557 21.4783H20.9849V27.449H26.9557V21.4783Z"
        stroke="white"
        stroke-width="1.27636"
        stroke-miterlimit="10"
      />
      <path
        d="M22.2124 32.1806C22.8772 32.1806 23.4161 31.6416 23.4161 30.9769C23.4161 30.3121 22.8772 29.7732 22.2124 29.7732C21.5477 29.7732 21.0088 30.3121 21.0088 30.9769C21.0088 31.6416 21.5477 32.1806 22.2124 32.1806Z"
        stroke="white"
        stroke-width="1.27636"
        stroke-miterlimit="10"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M26.9556 24.4697H30.0185L30.8646 23.6355"
        fill="white"
      />
      <path
        d="M26.9556 24.4697H30.0185L30.8646 23.6355"
        stroke="white"
        stroke-width="1.27636"
        stroke-miterlimit="10"
      />
      <path
        d="M31.7108 23.9813C32.3755 23.9813 32.9144 23.4424 32.9144 22.7777C32.9144 22.1129 32.3755 21.574 31.7108 21.574C31.046 21.574 30.5071 22.1129 30.5071 22.7777C30.5071 23.4424 31.046 23.9813 31.7108 23.9813Z"
        stroke="white"
        stroke-width="1.27636"
        stroke-miterlimit="10"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M20.9968 24.4697H17.934L17.0998 23.6355"
        fill="white"
      />
      <path
        d="M20.9968 24.4697H17.934L17.0998 23.6355"
        stroke="white"
        stroke-width="1.27636"
        stroke-miterlimit="10"
      />
      <path
        d="M16.2417 23.9813C16.9065 23.9813 17.4454 23.4424 17.4454 22.7777C17.4454 22.1129 16.9065 21.574 16.2417 21.574C15.577 21.574 15.0381 22.1129 15.0381 22.7777C15.0381 23.4424 15.577 23.9813 16.2417 23.9813Z"
        stroke="white"
        stroke-width="1.27636"
        stroke-miterlimit="10"
      />
      <path
        d="M25.7877 19.5477C26.4525 19.5477 26.9914 19.0088 26.9914 18.3441C26.9914 17.6793 26.4525 17.1404 25.7877 17.1404C25.123 17.1404 24.584 17.6793 24.584 18.3441C24.584 19.0088 25.123 19.5477 25.7877 19.5477Z"
        stroke="white"
        stroke-width="1.27636"
        stroke-miterlimit="10"
      />
      <path d="M25.2872 23.1472H22.6534V25.781H25.2872V23.1472Z" fill="white" />
    </svg>
  );
};

export default IconEvolve;
